<template>
  <div :style="nodeStyle" :key="key">
    <el-button class="service-button" @click="handleClick">
      <div>{{ label }}</div>
      <i :class="icon" />
    </el-button>
    <flow-chart
      v-if="isCallActivity"
      ref="flowChart"
      :fullscreen="false"
      width="80%"
    />
  </div>
</template>

<script>
  import getNodeMixin from '../mixins/getNode'

  export default {
    name: 'ServiceTask',
    mixins: [getNodeMixin],
    computed: {
      isCallActivity() {
        return this.data?.type === 'bpmn:CallActivity'
      },
      icon() {
        return this.isCallActivity
          ? 'el-icon-setting'
          : 'el-icon-circle-plus-outline'
      },
    },
    methods: {
      handleClick() {
        if (!this.isCallActivity) return
        const node = this.getNode()

        const params = {
          ...this.data?.params,
          nodeId: node?.id,
          type: 'subFlow',
        }

        this.$refs.flowChart.handleOpen(params)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .service-button.el-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 60px;
    margin-left: 0px;
    font-size: 13px;
    color: #fff;
    background-color: #5a6dff;
    border-color: #5a6dff;
    border-radius: 14px;

    i {
      margin-top: 6px;
      font-size: 14px;
      font-weight: bold;
      color: #cbe9ff;
    }

    &:focus,
    &:hover {
      color: #fff !important;
      background-color: #5a6dff !important;
      border-color: #5a6dff !important;
    }
  }
</style>
